import { createQueryHook } from '../../createQueryHook'

export default createQueryHook<void, any>({
  getKey: () => ['identity/users?roleId=959afe80-9709-457f-b785-330a3eab0279&skipCount=0&maxResultCount=999'],
  getEndpoint: () => 'identity/users?roleId=959afe80-9709-457f-b785-330a3eab0279&skipCount=0&maxResultCount=999'
})
